export class AutoLoginTokenResult {
  token = "";
  esa_token = "";
}
